import { render } from "./HeaderTag.vue?vue&type=template&id=3c0d7cff&scoped=true"
import script from "./HeaderTag.vue?vue&type=script&lang=js"
export * from "./HeaderTag.vue?vue&type=script&lang=js"

import "./HeaderTag.vue?vue&type=style&index=0&id=3c0d7cff&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c0d7cff"]])

export default __exports__